import React from 'react';
import { compose, setPropTypes, pure, withState } from 'recompose';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Modal from '@material-ui/core/Modal';
import DetailTextButton from '../atoms/DetailTextButton';
import DetailPostGroupModal from './DetailPostGroupModal';

const styles = {
  modalMobile: {
    width: '60%',
    height: 'auto',
    margin: ' 0 auto'
  },
  leftIcon: {
    padding: '0px 5px'
  },
  breakLine: {
    whiteSpace: 'pre-line'
  },
  verticalAlignTop: {
    verticalAlign: 'top'
  },
  buttonDelete: {
    paddingTop: '0px'
  },
  tableRow: {
    borderBottom: '1px solid #CCCCCC',
    backgroundColor: '#ffffff'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired,
  gochis: PropTypes.arrayOf(
    PropTypes.shape({
      gochiBillNo: PropTypes.string,
      couponId: PropTypes.number,
      groupName: PropTypes.string,
      menuName: PropTypes.string,
      shopName: PropTypes.string,
      price: PropTypes.number,
      type: PropTypes.string,
      registerDate: PropTypes.string,
      taxType: PropTypes.string,
      registerName: PropTypes.string,
      userName: PropTypes.string,
      useDate: PropTypes.string,
      expiration: PropTypes.string,
      shopMessage: PropTypes.string,
      gochiMessage: PropTypes.string,
      situation: PropTypes.string,
      thanksMessage: PropTypes.string
    })
  ).isRequired
};

const enhance = compose(
  pure,
  setPropTypes(propTypes),
  withState('openDetailPost', 'setDetailPost', false),
  withState('content', 'setContent', '')
);

const dateFormat = timeStr => {
  if (!timeStr) {
    return null;
  }
  const date = new Date(timeStr);
  const day = date.getDate();
  let month = date.getMonth() + 1;
  if (month < 10) {
    month = `0${month}`;
  }
  const year = date.getFullYear();
  return `${year}/${month}/${day}`;
};

const getDayOfWeek = date => {
  const dayOfWeek = new Date(date).getDay();
  return !dayOfWeek
    ? null
    : ['日', '月', '火', '水', '木', '金', '土'][dayOfWeek];
};

const GochiTableBody = enhance(
  ({
    classes,
    rssItems,
    content,
    setContent,
    setDetailPost,
    openDetailPost
  }) => {
    const detailOpenAction = params => {
      setContent(params);
      setDetailPost(true);
    };
    return (
      <>
        <TableBody>
          {rssItems
            // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((item, index) => {
              const key = `itemRss${index}`;
              const datePub = `${dateFormat(item.pubDate)} (${getDayOfWeek(
                item.pubDate
              )})`;
              const params = {
                title: item.title,
                content: item.content,
                pubDate: datePub
              };
              return (
                <TableRow key={key} className={classes.verticalAlignTop}>
                  <TableCell className={classes.tableRow}>
                    {item.pubDate && datePub}
                  </TableCell>
                  <TableCell
                    className={`${classes.tableRow} ${classes.breakLine}`}
                  >
                    {item.title}
                  </TableCell>
                  <TableCell className={classes.tableRow}>
                    <DetailTextButton
                      onClickAction={() => detailOpenAction(params)}
                    />
                  </TableCell>
                </TableRow>
              );
            })}
        </TableBody>
        <Modal
          open={openDetailPost}
          onClose={() => {
            setDetailPost(false);
          }}
          className={classes.modalMobile}
        >
          <DetailPostGroupModal
            setDetailPost={setDetailPost}
            params={content}
          />
        </Modal>
      </>
    );
  }
);

export default withStyles(styles)(GochiTableBody);
